// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"e1375348","213":"08dded21","453":"98fc7087","455":"020ca7be"}[chunkId] + ".chunk.js";
};